import moment from "moment";
import { toInstant } from './proposeLink';

function getProcessedFreeSlots(freeSlots) {
  const processedFreeSlots = {};
  if (!Array.isArray(freeSlots) || freeSlots.length === 0) {
    return processedFreeSlots;
  }

  freeSlots.forEach((slot) => {
    const start = toInstant(slot.start_date_time);
    const end = toInstant(slot.end_date_time);
    if (!start || !end || end <= start) return;

    const slotStartLocal = moment(start);
    const slotEndLocal = moment(end);
    const startDateKey = slotStartLocal.format('YYYY-MM-DD');
    const endDateKey = slotEndLocal.format('YYYY-MM-DD');

    // If slot is within a single day
    if (startDateKey === endDateKey) {
      if (!processedFreeSlots[startDateKey]) {
        processedFreeSlots[startDateKey] = [];
      }
      processedFreeSlots[startDateKey].push({
        slotStart: slotStartLocal,
        slotEnd: slotEndLocal,
      });
      return;
    }

    // Slot spans multiple days: split into per-day slots
    // 1. Add first day (from slotStart to end of that day)
    if (!processedFreeSlots[startDateKey]) {
      processedFreeSlots[startDateKey] = [];
    }
    processedFreeSlots[startDateKey].push({
      slotStart: slotStartLocal,
      slotEnd: slotStartLocal.clone().endOf('day'),
    });

    // 2. Add all full days in between
    const currentDay = slotStartLocal.clone().add(1, 'day').startOf('day');
    while (currentDay.isBefore(slotEndLocal, 'day')) {
      const currentDateKey = currentDay.format('YYYY-MM-DD');
      if (!processedFreeSlots[currentDateKey]) {
        processedFreeSlots[currentDateKey] = [];
      }
      processedFreeSlots[currentDateKey].push({
        slotStart: currentDay.clone(),
        slotEnd: currentDay.clone().endOf('day'),
      });
      currentDay.add(1, 'day');
    }

    // 3. Add last day (from start of day to slotEnd)
    if (!processedFreeSlots[endDateKey]) {
      processedFreeSlots[endDateKey] = [];
    }
    processedFreeSlots[endDateKey].push({
      slotStart: slotEndLocal.clone().startOf('day'),
      slotEnd: slotEndLocal,
    });
  });

  return processedFreeSlots;
}

export default getProcessedFreeSlots;
